/**
 * PROVISIONAL M0 VALUE — USER TUNING REQUIRED.
 *
 * Pointer feel belongs in a later user-led camera tuning pass.
 */
export const INPUT_TUNING = Object.freeze({
  pointerYawRadiansPerPixel: 0.0024,
});

/**
 * PROVISIONAL MOBILE CONTROL VALUES — USER TUNING REQUIRED.
 *
 * These values only shape the touch surface. They do not change simulation
 * movement speed or acceleration.
 */
export const TOUCH_INPUT_TUNING = Object.freeze({
  joystickRadiusCssPixels: 54,
  lookDeltaScale: 0.85,
});
